/**
 * Generated results from Moondream Query API (api.moondream.ai/v1/query)
 * 
 * 🤖 AUTO-GENERATED - DO NOT EDIT MANUALLY
 * Run: MOONDREAM_API_KEY=$(npx sst secret get MOONDREAM_API_KEY --stage $(whoami)) \
 *        npx tsx components/solutions/robot-vision/generate-examples.ts
 * 
 * Last generated: 2025-10-30T02:36:59.646Z
 */

export interface ExampleResult {
  response: string;
  responseTimeMs: number;
  inputTokens: number;
  outputTokens: number;
  imageExt?: string;
}

export const exampleResults: Record<string, ExampleResult> = {
  'laundry-dirty': {
    response: `[
  {
    "x_min": 0.3959978563299161,
    "y_min": 0.6305546994754534,
    "x_max": 0.5209131896133878,
    "y_max": 0.7418793181198544
  },
  {
    "x_min": 0.5072101051686715,
    "y_min": 0.8161747350148886,
    "x_max": 0.7264164832966267,
    "y_max": 0.9902768778883372
  },
  {
    "x_min": 0.024318775288883,
    "y_min": 0.7399470321459622,
    "x_max": 0.2044202276436683,
    "y_max": 0.8631810225949956
  }
]`,
    responseTimeMs: 1825,
    inputTokens: 733,
    outputTokens: 20,
    imageExt: 'jpg',
  },
  'laundry-basket': {
    response: `[
  {
    "x_min": 0.19150848668453413,
    "y_min": 0.6840621086640302,
    "x_max": 0.35981116140930747,
    "y_max": 0.9092907750114341
  }
]`,
    responseTimeMs: 670,
    inputTokens: 733,
    outputTokens: 10,
    imageExt: 'jpg',
  },
  'dishes-dirty': {
    response: `[
  {
    "x_min": 0.4222182512910134,
    "y_min": 0.5794431174211956,
    "x_max": 0.7038814554538547,
    "y_max": 0.9063828845338386
  }
]`,
    responseTimeMs: 671,
    inputTokens: 732,
    outputTokens: 10,
    imageExt: 'jpg',
  },
  'dishes-sponge': {
    response: `[
  {
    "x_min": 0.6434533456694933,
    "y_min": 0.5320376018806122,
    "x_max": 0.7426659114175058,
    "y_max": 0.6272976864869343
  }
]`,
    responseTimeMs: 688,
    inputTokens: 731,
    outputTokens: 10,
    imageExt: 'jpg',
  }
};
